import { render, staticRenderFns } from "./MassData.vue?vue&type=template&id=d13016ea&scoped=true&"
import script from "./MassData.vue?vue&type=script&lang=js&"
export * from "./MassData.vue?vue&type=script&lang=js&"
import style0 from "./MassData.vue?vue&type=style&index=0&id=d13016ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13016ea",
  null
  
)

export default component.exports